export const RGIconComponent = ({
  size = 32,
  fillColor = '#FFFFFF00',
  strokeColor = '#454545',
  strokeWidth = 1.5,
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="32" height="32" rx="16" fill={fillColor} />
    <path d="M18 13.3332H19.3333M18 15.9998H19.3333M12.6667 18.6665H19.3333M12 10.6665H20C21.1046 10.6665 22 11.5619 22 12.6665V19.3332C22 20.4377 21.1046 21.3332 20 21.3332H12C10.8954 21.3332 10 20.4377 10 19.3332V12.6665C10 11.5619 10.8954 10.6665 12 10.6665ZM15.3333 14.6665C15.3333 15.4029 14.7364 15.9998 14 15.9998C13.2636 15.9998 12.6667 15.4029 12.6667 14.6665C12.6667 13.9301 13.2636 13.3332 14 13.3332C14.7364 13.3332 15.3333 13.9301 15.3333 14.6665Z" stroke={strokeColor} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
